import { color, flexbox, layout, space, typography } from "styled-system";
import styled from "styled-components";
import { remCalc, media } from "../../theme/style-utils-coras-nua";
import defaultTheme from "../../theme/theme-test-override";

const StyledField = styled.div`
    /* 1. General Styles */
    visibility: visible;
    opacity: 1;
    transition: opacity ease-in-out 500ms;
    padding-bottom: ${remCalc(32)};
    display: flex;
    flex-direction: column;
    > p:last-child {
        margin-bottom: 0;
    }
    /* 2. Styles for classes added via Gravity admin */
    &.disabled.remove-optional,
    &.remove-optional {
        .optional {
            display: none;
        }
    }
    &.disabled,
    &.readonly,
    &.disabled.hide,
    &.readonly.hide {
        transition: none;
    }
    &.hide {
        visibility: hidden;
        opacity: 0;
        position: fixed;
        width: ${remCalc(1)};
        height: ${remCalc(1)};
    }
    &.info-message-trigger {
        .checkbox {
            .field-label {
                padding-left: ${remCalc(0)};
                color: ${props => props.theme.colors.primary};
                font-weight: ${props => props.theme.fontWeights.semiBold};
                text-decoration: underline;
                &:hover {
                    color: ${props => props.theme.colors.primaryTone};
                }
                justify-content: flex-start;
                cursor: pointer;
                &:before {
                    content: none;
                }
            }
        }
        input:checked + label { 
            &:after {
                z-index: 3;
                position: fixed;
                bottom: 0;
                left: 0;
                background-color: ${props => props.theme.colors.brilliant};
                background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIxNXB4IiB2aWV3Qm94PSIwIDAgMjAgMTUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjEgKDcyNjMxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5sPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkIiBmaWxsPSIjMTA2OTg4IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNOC4wMjU1MjA1MiwxNC43OTM5OTY2IEM3Ljc1MDk3NzQ3LDE1LjA2ODU5NjkgNy4zMDU3NDYyMywxNS4wNjg1OTY5IDcuMDMxMjAzMTgsMTQuNzk0MDUzOSBMMC4yMDU5MDcyODgsNy45Mzg1NzgyOCBDLTAuMDY4NjM1NzYyOCw3LjY2MzkyMDc5IC0wLjA2ODYzNTc2MjgsNy4zMzU5Mjk1IDAuMjA1OTA3Mjg4LDcuMDYxMzI5MjMgTDcuMDMxMjAzMTgsMC4yMDU5MDcyODggQzcuMzA1NzQ2MjMsLTAuMDY4NjM1NzYyOCA3Ljc1MDk3NzQ3LC0wLjA2ODYzNTc2MjggOC4wMjU1MjA1MiwwLjIwNTkwNzI4OCBMOC40Mzk4NTI3OSwwLjYyMDE4MjMzOSBDOC43MTQzOTU4NCwwLjg5NDgzOTgzIDguNzE0Mzk1ODQsMS4zNDAwMTM4NSA4LjQzOTg1Mjc5LDEuNjE0NTU2OSBMMy41MjIyMjQ4NCw2LjU2MjQyNTM0IEwxOS4yOTk5Njk1LDYuNTYyNDI1MzQgQzE5LjY4ODI2NjUsNi41NjI0MjUzNCAxOS45OTk5Njk1LDYuODE4Njg2OTUgMTkuOTk5OTY5NSw3LjIwNjk4Mzk3IEwxOS45OTk5Njk1LDcuNzkyOTE5OTYgQzE5Ljk5OTk2OTUsOC4xODEyMTY5OSAxOS42ODgyNjY1LDguNDM3NDI0OTUgMTkuMjk5OTY5NSw4LjQzNzQyNDk1IEwzLjUyMjIyNDg0LDguNDM3NDI0OTUgTDguNDM5ODUyNzksMTMuMzg1MzQ3IEM4LjcxNDM5NTg0LDEzLjY1OTk0NzMgOC43MTQzOTU4NCwxNC4xMDUxMjEzIDguNDM5ODUyNzksMTQuMzc5NzIxNiBMOC4wMjU1MjA1MiwxNC43OTM5OTY2IFoiIGlkPSJsIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=");
                background-repeat: no-repeat;
                background-size: ${remCalc(17)};
                background-position: 17.5% ${remCalc(35)};
                padding-left: 28%;
                padding-right: 20%;
                ${media.sm.down`
                    padding-left: ${remCalc(50)};
                    padding-right: ${remCalc(25)};
                    background-position: ${remCalc(25)} ${remCalc(35)};`}
                height: ${remCalc(176)};
                ${media.sm.down`
                    height: ${remCalc(84)}`}
                line-height: ${remCalc(83)};
                width: 100%;
                font-weight: ${props => props.theme.fontWeights.semiBold};
                color: ${props => props.theme.colors.primary};
                content: "Back";
                text-align: left;
            }
        }
    }
    &.info-message {
        /* If a field has class .info-message, it generally works in conjunction with a trigger (above) that is set on another field. Because the back button on this .info-message field is an absolutely positioned :after element of the .info-message-trigger, we need adequate padding to ensure the :after tag does not cover any relevant content within the info-message: */
        padding: ${remCalc(100)} 20% ${remCalc(184)};
        ${media.sm.down`
            padding: ${remCalc(64)} ${remCalc(24)} ${remCalc(110)};`}
        overflow-y: scroll;
        position: fixed;
        /* cannot control the height of the page and stop the body from scrolling => can't support showing the header in this scenario */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: white;
        z-index: 1;
        > div {
            position: relative;
            margin-left: auto;
            margin-right: auto;
            max-width: ${remCalc(500)};
            img {
                width: 80%;
                height: auto;
            }
        }
    }
    & * {
        order: 5;
    }
    &.poa-img-alignment{
        img {
            max-width: 100%;
        }
        ${media.md.up`
            img {
                float: left;
                max-width: ${remCalc(200)};
                margin-right: ${remCalc(24)};
            }
        `}
    }
    /* The field control itself is always third */
    & input,
    & textarea,
    & select,
    & .phone-field,
    & .instructions {
        order: 3;
    }
    &.error {
        input,
        textarea,
        select {
            border-color: ${props => props.theme.colors.alert};
            &:focus {
                border-color: ${props => props.theme.colors.alert};
            }
        }
    }
    &.all-options-inline {
        .radio {
            &.layout {
                &-1 {
                    > div {
                        width: calc(1 / 1 * 100% - (1 - 1 / 1) * ${remCalc(
                            10
                        )});
                    }
                }
                &-2 {
                    > div {
                        width: calc(1 / 2 * 100% - (1 - 1 / 2) * ${remCalc(
                            10
                        )});
                    }
                }
                &-3 {
                    > div {
                        width: calc(1 / 3 * 100% - (1 - 1 / 3) * ${remCalc(
                            10
                        )});
                    }
                }
                &-4 {
                    > div {
                        width: calc(1 / 4 * 100% - (1 - 1 / 4) * ${remCalc(
                            10
                        )});
                    }
                }
                ${"" /* For screenns above mobile */}
                ${media.sm.down`
                    &-5 {
                        > div {
                            width: calc(1 / 5 * 100% - (1 - 1 / 5) * ${remCalc(
                                10
                            )});
                        }
                    }
                    &-6 {
                        > div {
                            width: calc(1 / 6 * 100% - (1 - 1 / 6) * ${remCalc(
                                10
                            )});
                        }
                    }`}
            }
        }
    }
    &.application-stage {
        ol {
            color: ${props => props.theme.colors.monotoneMidDark};
            font-size: ${remCalc(15)};
            li {
                padding: ${remCalc(10)} 0;
            }
            &.tick-circle-full {
                list-style: none;
                padding-left: 0;
                li {
                    background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjVweCIgaGVpZ2h0PSIyNXB4IiB2aWV3Qm94PSIwIDAgMjUgMjUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjEgKDcyNjMxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5saXN0LXRpY2stY2lyY2xlLWZpbGw8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0ibGlzdC10aWNrLWNpcmNsZS1maWxsIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMjQuMjQ5OTk5NCwxMi4yNTAwMzI4IEMyNC4yNDk5OTk0LDE4Ljg3NzQ1ODQgMTguODc3NDI1MSwyNC4yNTAwMzI4IDEyLjI0OTk5OTQsMjQuMjUwMDMyOCBDNS42MjI1NzM3NSwyNC4yNTAwMzI4IDAuMjQ5OTk5NDA0LDE4Ljg3NzQ1ODQgMC4yNDk5OTk0MDQsMTIuMjUwMDMyOCBDMC4yNDk5OTk0MDQsNS42MjI2MDcxMyA1LjYyMjU3Mzc1LDAuMjUwMDMyNzgzIDEyLjI0OTk5OTQsMC4yNTAwMzI3ODMgQzE4Ljg3NzQyNTEsMC4yNTAwMzI3ODMgMjQuMjQ5OTk5NCw1LjYyMjYwNzEzIDI0LjI0OTk5OTQsMTIuMjUwMDMyOCBaIE0xMC44NjE5ODkxLDE4LjYwMzk1NzkgTDE5Ljc2NTIxNDksOS43MDA3MzIxMyBDMjAuMDY3NDkyNSw5LjM5ODQwNzI4IDIwLjA2NzQ5MjUsOC45MDgxNTcxNSAxOS43NjUyMTQ5LDguNjA1ODMyMyBMMTguNjcwMzE1MSw3LjUxMDk3OTczIEMxOC4zNjgwMzc1LDcuMjA4NjA3NjMgMTcuODc3Nzg3Myw3LjIwODYwNzYzIDE3LjU3NTQxNTIsNy41MTA5Nzk3MyBMMTAuMzE0NTE1NSwxNC43NzE4Nzk0IEw2LjkyNDU4MzU4LDExLjM4MTkwMDIgQzYuNjIyMjU4NzMsMTEuMDc5NTc1NCA2LjEzMjAwODYsMTEuMDc5NTc1NCA1LjgyOTY4Mzc1LDExLjM4MTkwMDIgTDQuNzM0NzgzOTMsMTIuNDc2NzUyOCBDNC40MzI1MDYzMywxMi43NzkwNzc2IDQuNDMyNTA2MzMsMTMuMjY5MzI3OCA0LjczNDc4MzkzLDEzLjU3MTY1MjYgTDkuNzY3MDQxOTksMTguNjAzOTEwNyBDMTAuMDY5NDE0MSwxOC45MDYyMzU1IDEwLjU1OTYxNywxOC45MDYyMzU1IDEwLjg2MTk4OTEsMTguNjAzOTU3OSBaIiBpZD0i74GYIiBmaWxsPSIjMTA2OTg4IiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4KICAgIDwvZz4KPC9zdmc+");
                    background-repeat: no-repeat;
                    background-size: ${remCalc(20)} ${remCalc(20)};
                    background-position: 0 ${remCalc(11)};
                    padding-left: ${remCalc(30)};
                    margin-left: 0;
                }
            }

            counter-reset: list-counter;
            list-style: none;
            padding-left: 0;
            border-left: 0 solid
                ${props => props.theme.colors.monotoneMidLight};
            margin-left: ${remCalc(24)};
            li {
                padding: 0;
                margin-left: 0;
                position: relative;
                left: ${remCalc(-16)};
                margin-top: ${remCalc(30)};
                margin-bottom: r ${remCalc(30)};
                padding-left: ${remCalc(46)};
                font-weight: ${props => props.theme.fontWeights.semiBold};
                color: ${props => props.theme.colors.monotoneMidLight};
                transition: all 500ms ease-in;
                &:before {
                    counter-increment: list-counter;
                    content: counter(list-counter);
                    position: absolute;
                    top: ${remCalc(-6)};
                    left: 0;
                    width: ${remCalc(26)};
                    height: ${remCalc(26)};
                    line-height: ${remCalc(26)};
                    font-size: ${remCalc(16)};
                    font-weight: ${props => props.theme.fontWeights.regular};
                    border-radius: 100%;
                    background-color: ${props => props.theme.colors.brilliant};
                    text-align: center;
                    border: ${remCalc(2)} solid
                        ${props => props.theme.colors.monotoneMidLight};
                    color: ${props => props.theme.colors.monotoneMidLight};
                    transition: background-color 500ms, border-color 500ms, color 500ms;
                }
                &:after {
                    position: absolute;
                    content: " ";
                    width: ${remCalc(2)};
                    height: 100%;
                    background: ${props => props.theme.colors.monotoneMidLight};
                    left: ${remCalc(14)};
                    top: ${remCalc(24)};
                    transition: height 500ms ease-in;
                }
                &:last-child {
                    &:after {
                        height: 0;
                    }
                }
                &.active {
                    color: ${props => props.theme.colors.primary};
                    &:before {
                        border-color: ${props => props.theme.colors.primary};
                        color: ${props => props.theme.colors.primary};
                    }
                }
            }
        }

        &.stage-one li:nth-child(1),
        &.stage-two li:nth-child(2),
        &.stage-three li:nth-child(3),
        &.stage-four li:nth-child(4) {
            color: ${props => props.theme.colors.primary};
            &:before {
                border-color: ${props => props.theme.colors.primary};
                color: ${props => props.theme.colors.primary};
            }
        }

        &.stage-two li:nth-child(1),
        &.stage-three li:nth-child(1),
        &.stage-three li:nth-child(2),
        &.stage-four li:nth-child(1),
        &.stage-four li:nth-child(2),
        &.stage-four li:nth-child(3) {
            color: ${props => props.theme.colors.primary};
            &:before {
                content: " ";
                border-color: ${props => props.theme.colors.primary};
                background-color: ${props => props.theme.colors.primary};
                background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzJweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMzIgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjEgKDcyNjMxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5jaGVjay13aGl0ZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJjaGVjay13aGl0ZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTEwLjg2ODYyNjQsMjMuNDYyNzY5OCBMMC40Njg2MjY4MTIsMTMuMDYyNzcwMiBDLTAuMTU2MTg4NTkyLDEyLjQzNzk1NDggLTAuMTU2MTg4NTkyLDExLjQyNDg5NTcgMC40Njg2MjY4MTIsMTAuODAwMDE5MyBMMi43MzEzMTY3Myw4LjUzNzI2ODMxIEMzLjM1NjEzMjE0LDcuOTEyMzkxODcgNC4zNjkyNTIyOCw3LjkxMjM5MTg3IDQuOTk0MDY3NjgsOC41MzcyNjgzMSBMMTEuOTk5OTcxNCwxNS41NDMxNzIgTDI3LjAwNTg1NiwwLjUzNzI4NzM4NSBDMjcuNjMwNjcxNCwtMC4wODc1MjgwMTk5IDI4LjY0Mzc5MTYsLTAuMDg3NTI4MDE5OSAyOS4yNjg2MDcsMC41MzcyODczODUgTDMxLjUzMTI5NjksMi44MDAwMzgzNCBDMzIuMTU2MTEyMywzLjQyNDg1Mzc0IDMyLjE1NjExMjMsNC40Mzc5MTI4NSAzMS41MzEyOTY5LDUuMDYyNzg5MjkgTDEzLjEzMTMxNjMsMjMuNDYyODMwOSBDMTIuNTA2NDM5OSwyNC4wODc2NDYzIDExLjQ5MzM4MDgsMjQuMDg3NjQ2MyAxMC44Njg2MjY0LDIzLjQ2Mjc2OTggWiIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICA8L2c+Cjwvc3ZnPg==");
                background-repeat: no-repeat;
                background-size: ${remCalc(14)};
                background-position: center center;
                color: ${props => props.theme.colors.brilliant};
            }
            &:after {
                background: ${props => props.theme.colors.primary};
            }
        }
    }
`;
StyledField.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

const LabelContainer = styled("div")`
    ${layout}
    ${flexbox}
    ${space}
    align-items: flex-start;
    order: 1;
    .field-label {
        color: ${props => props.theme.colors.monotoneDark};
        font-size: ${remCalc(16)};
        line-height: ${remCalc(24)};
        font-weight: ${props => props.theme.fontWeights.semiBold};
        display: inline;
        margin-left: 0;
        padding-left: 0;
        &.field-sub-label {
            color: ${props => props.theme.colors.monotoneDark};
            font-size: ${remCalc(14)};
            line-height: ${remCalc(24)};
            font-weight: ${props => props.theme.fontWeights.regular};
            display: block;
            margin-top: ${remCalc(0)};
            margin-bottom: ${remCalc(-4)};
        }
    }
    .field-sub-label {
        color: ${props => props.theme.colors.monotoneDark};
        font-size: ${remCalc(14)};
        line-height: ${remCalc(24)};
        font-weight: ${props => props.theme.fontWeights.regular};
        display: block;
        margin-top: ${remCalc(0)};
        margin-bottom: ${remCalc(-4)};
    }
`;
LabelContainer.defaultProps = {
    theme: {
        ...defaultTheme
    },
    display: "inline",
    pb: remCalc(8)
};

const FieldDescription = styled("div")`
    ${color}
    ${typography}
    ${space}
    order: 2;
    * {
        font-size: ${remCalc(14)};
        &:last-child {
            margin-bottom: 0;
        }
    }
    ul{
        margin-top: 0;
        margin-left: ${remCalc(32)};
        li{
            padding-top: 0;
        }
    }
    &.below {
        margin-top: ${remCalc(10)};
        margin-bottom: 0;
        order: 4;
    }
`;
FieldDescription.defaultProps = {
    theme: {
        ...defaultTheme
    },
    color: "monotoneDark",
    fontSize: 1,
    mb: 2,
    mt: -1
};

const FieldError = styled("div")`
    ${typography}
    ${color}
    ${space}
    order: 5;
`;
FieldError.defaultProps = {
    theme: {
        ...defaultTheme
    },
    fontSize: 2,
    mt: 1,
    color: "alert"
};

export { StyledField, LabelContainer, FieldDescription, FieldError };
